export default __webpack_public_path__ + "static/media/favicon.ca602ffc.ico";